/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum TemplateDeliveryMethod {
  EMAIL="EMAIL",
SMS="SMS"
}

/**
* TemplateDeliveryMethod
*/
export const TemplateDeliveryMethodEnumType = types.enumeration("TemplateDeliveryMethod", [
        "EMAIL",
  "SMS",
      ])
